import { render, staticRenderFns } from "./ReailzeCard.vue?vue&type=template&id=34b2ca35&scoped=true"
import script from "./ReailzeCard.vue?vue&type=script&lang=js"
export * from "./ReailzeCard.vue?vue&type=script&lang=js"
import style0 from "./ReailzeCard.vue?vue&type=style&index=0&id=34b2ca35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b2ca35",
  null
  
)

export default component.exports